module.exports = __webpack_public_path__ + "img/quikr1.79798118.png";